import React, { useState } from "react";
import categories from "../../assets/data/category";
import CategoryAdd from "../../components/admin/popup/Category/CategoryAdd";
import Delete from "../../components/admin/popup/Delete/Delete";

function CategoryList() {
  const TotalCategories = categories.length;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    console.log(`Deleting category: ${categoryToDelete.Category}`);
    setShowDeleteModal(false);
    setCategoryToDelete(null);
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setCategoryToDelete(null);
  };

  return (
    <div className="MainDashboard flex items-center justify-center">
      <div className="w-[100%] rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">Categories</h2>
          <div className="bel flex flex-wrap items-center gap-4">
            <CategoryAdd />

            <div className="relative">
              <i
                className="fa fa-bell text-[24px] relative"
                aria-hidden="true"
              ></i>
              {TotalCategories > 0 && (
                <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                  {TotalCategories}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Scrollable List Container */}
        <div className="overflow-y-auto md:h-[450px] h-[70vh] "  >
          <table className="w-full border-collapse text-sm">
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Category</th>
                <th className="p-2 border-b">
                  SubCategory
                </th>
                <th className="p-2 border-b">Image</th>
                <th className="p-2 border-b">Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr className="hover:bg-gray-100" key={category._id}>
                  <td className="p-2 border-b text-center">
                    {category.Category}
                  </td>
                  <td className="p-2 border-b text-center">
                    {category.Category}
                  </td>
                  <td className="p-2 border-b flex items-center justify-center">
                    <img
                      src={category.image}
                      alt={category.Category}
                      className="w-10 h-10 object-contain rounded-md"
                    />
                  </td>
                  <td className="p-2 border-b text-center">
                    <i
                      className="fa fa-trash text-red-600 hover:text-red-800 cursor-pointer"
                      aria-hidden="true"
                      onClick={() => handleDeleteClick(category)}
                    ></i>
                    <i
                      className="fa fa-edit text-primary hover:text-primary/90 cursor-pointer ml-2"
                      aria-hidden="true"
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showDeleteModal && categoryToDelete && (
        <Delete
          image={categoryToDelete.image}
          name={categoryToDelete.Category}
          onDelete={handleDeleteConfirm}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
}

export default CategoryList;
